import Vue from 'vue';
import VueRouter from 'vue-router';
import ROUTES from '@/routes';
import {ROUTER_DEFAULT_CONFIG} from '@/config';
import {routerBeforeEachFunc, routerAfterEachFunc} from '@/config/interceptors';

Vue.use(VueRouter);
// // 解决编程式路由往同一地址跳转时会报错的情况
// const originalPush = VueRouter.prototype.push;
// const originalReplace = VueRouter.prototype.replace;
// // push
// VueRouter.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) {
//     return originalPush.call(this, location, onResolve, onReject);
//   }
//   return originalPush.call(this, location).catch(err => err);
// };
// // replace
// VueRouter.prototype.replace = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) {
//     return originalReplace.call(this, location, onResolve, onReject);
//   }
//   return originalReplace.call(this, location).catch(err => err);
// };
export function createNewRoute() {
  return new VueRouter({
    ...ROUTER_DEFAULT_CONFIG,
    routes: ROUTES
  });
}

// 注入默认配置和路由表
// let routerInstance = new VueRouter({
//   ...ROUTER_DEFAULT_CONFIG,
//   routes: ROUTES
// })
export let routerInstance = createNewRoute();
// 注入拦截器
routerInstance.beforeEach(routerBeforeEachFunc);

routerInstance.afterEach(routerAfterEachFunc);

export default routerInstance;
